module.exports = __webpack_public_path__ + "static/media/msg.160810bd.jpg";